import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {isNil} from 'lodash';
import {Router} from 'src/app/infrastructure/router/router';
import {WebComponent} from 'src/app/ui/webapp/component/web.component';

type UrlMatchType = 'full' | 'startsWith';
@Component({
  template: ''
})
export abstract class BaseMenuItemComponent extends WebComponent implements OnChanges {
  @Input() route: string | null = null;
  @Input() typeOfUrlMatchToActiveItem: UrlMatchType = 'startsWith';

  active = false;

  protected constructor(
    private readonly router: Router,
  ) {
    super();
  }

  clickOnItem(event: MouseEvent) {
    if (this.active) {
      event.stopPropagation();
      return;
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.route) {
      this.updateActiveState();
    }
  }

  protected onInit() {
    super.onInit();

    this.updateActiveState();

    this.subscribe(this.router.changed(), () => {
      this.updateActiveState();
    });
  }

  private updateActiveState(): void {
    if (!this.isRoutableItem()) {
      this.active = false;
      return;
    }

    const currentUrl = this.router.currentUrl().url;
    if (this.typeOfUrlMatchToActiveItem === 'startsWith') {
      this.active = currentUrl.startsWith(this.route);
    } else {
      this.active = currentUrl === this.route;
    }
  }

  private isRoutableItem(): boolean {
    return !isNil(this.route);
  }
}
